<template>
	<article class="flex flex-col bg-white border border-[#D6D6D7] rounded-lg overflow-hidden p-5 cursor-pointer">
		<div class="relative w-full flex justify-between items-stretch gap-0.5">
			<div class="flex flex-col gap-2.5 text-[#1E293B] relative z-10">
				<small class="font-bold text-xs">Total de factura</small>
				<p class="text-[32px] font-bold leading-[36px]">{{ parseCurrency(props.item.vendorElectricalConsumption) }}</p>
				<Badge class="w-fit !text-[#06426B] !text-[11px] !bg-[#06426B]/10 !whitespace-nowrap !font-semibold" size="xs" :color="props.item.recommended ? 'success' : 'warning'">{{ props.item.offerType }}</Badge>
			</div>
			<div class="flex flex-col vendor-logo-container items-end justify-between absolute top-0 right-0 h-full">
				<div class="vendor-logo flex items-center justify-center">
					<img class="h-full w-full object-contain" :src="props.item.vendorLogo" :alt="props.item.vendorName" />
				</div>
				<div class="text-[#1E293B]">
					<svg xmlns="http://www.w3.org/2000/svg" width="10" height="18" viewBox="0 0 10 18" fill="none">
						<path d="M0.19165 15.8583L1.66665 17.3333L9.99998 9L1.66665 0.666672L0.19165 2.14167L7.04998 9L0.19165 15.8583Z" fill="currentColor" />
					</svg>
				</div>
			</div>
		</div>
	</article>
</template>

<style lang="scss" scoped>
article {
	container-type: inline-size;
	container-name: comparative-card;

	.vendor-logo {
		width: 120px;
		height: 56px;
	}

	@media (min-width: 768px) {
		@container comparative-card (min-width: 500px) {
			.vendor-logo-container {
				flex-direction: row;
				gap: 30px;
				align-items: center;

				.vendor-logo {
					width: 204px;
					height: 70px;
				}
			}
		}
	}
}
</style>

<script setup lang="ts">
import Badge from '@/apps/go/components/Badge.vue'
import { parseCurrency } from '../../utils/parseCurrency'
const props = defineProps<{ item: any }>()
</script>
